import React from 'react';
import './ProductPage.sass';

import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import Helmet from 'react-helmet';
import {injectIntl} from 'react-intl';
import * as Cookie from "js-cookie";

import {setAlternateResources} from '../../ducks/channels';
import {fetchProductBySlug} from '../../ducks/products';
import {fetchTaxonChildrenBySlug} from '../../ducks/taxons';
import {fetchEventProductsByProduct} from '../../ducks/eventProducts';
import {fetchReviews} from '../../ducks/reviews';
import {addProductToCart} from '../../ducks/cart';
import {
  analyticsClearEcommerce,
  analyticsProductDetailsView,
  analyticsViewProductOrCategory,
} from '../../middlewares/analytics/actions';
import {openModal, setBackground, setMainTaxonDropdownVisibility} from '../../ducks/ui';

import {findProductMenuTaxon, taxonNestedSet} from '../../utils/taxons';

import withChannelFormatters from '../channelUtils/withChannelFormatters';
import {channelImageUrl} from '../channelUtils/ChannelImage';
import syncLocation from '../syncLocation/syncLocation';

import {itemOccurrences} from '../../utils/itemOccurrences';
import {buildBreadcrumbsList} from '../../utils/buildBreadcrumbsList';

import {closestBackgroundImage} from '../../components/background/Background';

import Menu from '../../components/menu/Menu';
import Breadcrumbs from '../../components/breadcrumbs/Breadcrumbs';
import Products from '../../components/products/Products';
import ProductPurchase from '../../components/productPurchase/ProductPurchase';
import Loader from '../../components/loader/Loader';
import ErrorPage from '../errorPage/ErrorPage';
import Meta from '../../components/meta/Meta';
import JSONLDBreadcrumbs from '../../components/JSON-LD/JSONLDBreadcrumbs';
import JSONLDProduct from '../../components/JSON-LD/JSONLDProduct';
import JSONLDBoosthive from '../../components/JSON-LD/JSONLDBoosthive';
import { formatPrice } from '../../components/JSON-LD/utils';
import CartModalContainer from '../cartModalContainer/CartModalContainer';
import WysiwygHtml from '../../components/rawHtml/WysiwygHtml';
import ReviewsSwiper from '../../components/reviews/ReviewsSwiper';
import ChannelLink from '../channelUtils/ChannelLink';

const canonicalMap = {
};

const metaMap = {
  'weekly-bundle': [{"name": "googlebot", "content": "noindex"}],
  'anniversary-classic-quick-start-bundle': [{"name": "googlebot", "content": "noindex"}],
  'mythic-dungeons-bundle': [{"name": "googlebot", "content": "noindex"}],
  'glory-bundle': [{"name": "googlebot", "content": "noindex"}],
  'd4-starter-bundle': [{"name": "googlebot", "content": "noindex"}],
  'nightmare-bundle': [{"name": "googlebot", "content": "noindex"}],
  'mythic-raids-bundle': [{"name": "googlebot", "content": "noindex"}],
  'wow-delves-bundle': [{"name": "googlebot", "content": "noindex"}],
  'wow-mythic-six-plus-two-bundle': [{"name": "googlebot", "content": "noindex"}],
  'black-ops-ultimate-camo-bundle': [{"name": "googlebot", "content": "noindex"}],
  'black-ops-ultimate-attachments-bundle': [{"name": "googlebot", "content": "noindex"}],
  'wow-mythic-12-six-plus-two-bundle': [{"name": "googlebot", "content": "noindex"}],
  'poe2-all-currency-bundle': [{"name": "googlebot", "content": "noindex"}],
  'poe2-hardcore-bundle': [{"name": "googlebot", "content": "noindex"}],
  'wow-mop-raids-bundle': [{"name": "googlebot", "content": "noindex"}],
  'anniversary-classic-raid-ready-bundle': [{"name": "googlebot", "content": "noindex"}],
  'anniversary-classic-pvp-bundle': [{"name": "googlebot", "content": "noindex"}],
  'wow-the-war-within-bundle': [{"name": "googlebot", "content": "noindex"}],
  'wow-mythic-raid-mounts-bundle': [{"name": "googlebot", "content": "noindex"}],
  'anniversary-classic-all-raids-bundle': [{"name": "googlebot", "content": "noindex"}],
  'starter-bundle': [{"name": "googlebot", "content": "noindex"}],

  // List of disabled since 2025-06
  'wow-all-in-one-plunderstorm-bundle': [{"name": "googlebot", "content": "noindex"}],
  'pve-reroll-bundle': [{"name": "googlebot", "content": "noindex"}],
  'wow-anniversary-mounts-bundle': [{"name": "googlebot", "content": "noindex"}],
  'd4-rogue-uniques-bundle': [{"name": "googlebot", "content": "noindex"}],
  'd4-barbarian-uniques-bundle': [{"name": "googlebot", "content": "noindex"}],
  'd4-necromancer-uniques-bundle': [{"name": "googlebot", "content": "noindex"}],
  'd4-druid-uniques-bundle': [{"name": "googlebot", "content": "noindex"}],
  'd4-sorcerer-uniques-bundle': [{"name": "googlebot", "content": "noindex"}],
  'd4-spiritborn-uniques-bundle': [{"name": "googlebot", "content": "noindex"}],
  'd4-bundle': [{"name": "googlebot", "content": "noindex"}],
  'cataclysm-reroll-bundle': [{"name": "googlebot", "content": "noindex"}],
  'classic-bundle': [{"name": "googlebot", "content": "noindex"}],
  'icc-preparation-bundle': [{"name": "googlebot", "content": "noindex"}],
  'cataclysm-classic-all-raids-bundle': [{"name": "googlebot", "content": "noindex"}],
  'poe2-juiced-maps-bundle': [{"name": "googlebot", "content": "noindex"}],
  'wow-horrific-visions-bundle': [{"name": "googlebot", "content": "noindex"}],
  'classic-starter-bundle': [{"name": "googlebot", "content": "noindex"}],
  'classic-raid-ready-bundle': [{"name": "googlebot", "content": "noindex"}],
  'allied-race-bundle': [{"name": "googlebot", "content": "noindex"}],
  'pvp-reroll-bundle': [{"name": "googlebot", "content": "noindex"}],
  'torment-bundle': [{"name": "googlebot", "content": "noindex"}],
  'd4-uber-bundle': [{"name": "googlebot", "content": "noindex"}],
  'd2-trials-of-osiris-loot-shower-bundle': [{"name": "googlebot", "content": "noindex"}],
  'wow-world-mounts-bundle': [{"name": "googlebot", "content": "noindex"}],

  // name: robots
  'poe-2/all-currency-bundle': [{"name": "robots", "content": "noindex"}],
  'wow/raid-bundle': [{"name": "robots", "content": "noindex"}],
  'wow/m-plus-bundle': [{"name": "robots", "content": "noindex"}],
  'wow/glory-achievements-bundle': [{"name": "robots", "content": "noindex"}],
  'wow/pvp-reroll-bundle': [{"name": "robots", "content": "noindex"}],
  'wow/mythic-six-plus-two-bundle': [{"name": "robots", "content": "noindex"}],

  'custom': [{"name": "robots", "content": "noindex"}],
  'd2-custom': [{"name": "robots", "content": "noindex"}],
  'custom-wow': [{"name": "robots", "content": "noindex"}],
  'customs-raid': [{"name": "robots", "content": "noindex"}],
  'custom-cod': [{"name": "robots", "content": "noindex"}],
  'wow-classic-custom': [{"name": "robots", "content": "noindex"}],
  'poe2-custom': [{"name": "robots", "content": "noindex"}],
  'custom-sod': [{"name": "robots", "content": "noindex"}],
  'custom-last-epoch': [{"name": "robots", "content": "noindex"}],
  'custom-d4': [{"name": "robots", "content": "noindex"}],
  'custom-division2': [{"name": "robots", "content": "noindex"}],
  'custom-hd-2': [{"name": "robots", "content": "noindex"}],

  'tips-for-boosters': [{"name": "robots", "content": "noindex"}],

  'starter-pack': [{"name": "robots", "content": "noindex"}],
  'poe2-full-atlas-completion-bundle': [{"name": "robots", "content": "noindex"}],
  'cataclysm-classic-all-heroic-dungeons-bundle': [{"name": "robots", "content": "noindex"}],
  'poe2-league-starter-bundle': [{"name": "robots", "content": "noindex"}],

  'wow/delves-bundle': [{"name": "robots", "content": "noindex"}],
  'wow/starter-pack': [{"name": "robots", "content": "noindex"}],
};

@withChannelFormatters

@connect(({taxons, products, isLoading, isError, eventProducts, channels}, {params, location}) => ({
  isLoading: eventProducts.isLoading,
  isError: eventProducts.isError,
  product: products[params.splat],
  // Закомментировано для отключения eventPreset механизма, для восстановления работы eventPreset кверистринга и нового механизма, следует рефакторнуть следующие две строчку в одну. Для справки ознакомится с коммитом под этой строчкой и eventProducts.js reducer в частности.
  // productEvents: (products[params.splat] && eventProducts.product[products[params.splat].id]) && (location.query.eventPreset
  //    ? eventProducts.product[products[params.splat].id][location.query.eventPreset]
  //    : products[params.splat].eventOptionPreset && eventProducts.product[products[params.splat].id][products[params.splat].eventOptionPreset.id]),
  productEvents: (products[params.splat] && eventProducts.product[products[params.splat].id]) && (eventProducts.product[products[params.splat].id] && eventProducts.product[products[params.splat].id].items),
  menu: products[params.splat] && taxons.children[findProductMenuTaxon(products[params.splat]).slug],
  activeChannel: channels.activeChannel
}))
@injectIntl
@syncLocation(({product}) => product && findProductMenuTaxon(product).slug)
export default class ProductPage extends React.PureComponent {
  static fetchData = ({dispatch, location, params, cookies}) => dispatch(fetchProductBySlug(params.splat, cookies))
    .then(product => Promise.all([
      ProductPage.fetchRelatedData({dispatch, location, product}),
      dispatch(setAlternateResources(product.alternateSlugs, '/service'))
    ]));

  static fetchRelatedData = ({dispatch, location, product, productEvents, menu}) => Promise.all([
    menu === undefined && dispatch(fetchTaxonChildrenBySlug(findProductMenuTaxon(product).slug)),
    (productEvents === undefined || productEvents === null) && (
        dispatch(fetchEventProductsByProduct(product.id, location.query.eventPreset || ( product.eventOptionPreset && product.eventOptionPreset.id) || undefined ))
    )
  ]);

  static associationCode = 'See-also';

  // Enough to fill the reviews slider and the schema.org markup from one fetch.
  static reviewLimit = 10;

  state = {
    // The product's own reviews, shared between the slider and JSON-LD schema:
    // { items, total }, or undefined while loading.
    productReviews: undefined,
  };

  loadProductReviews(product) {
    const {dispatch} = this.props;
    const {code} = product;

    this.setState({productReviews: undefined});

    return dispatch(fetchReviews({productCode: code, ratingOrder: 'desc', limit: ProductPage.reviewLimit})).then(
      (res) => {
        if (this.props.product && this.props.product.code === code) {
          this.setState({productReviews: {items: (res.content && res.content.items) || [], total: (res.meta && res.meta.total) || 0, averageRating: res.meta && res.meta.averageRating}});
        }
      },
      () => {
        if (this.props.product && this.props.product.code === code) {
          this.setState({productReviews: {items: [], total: 0}});
        }
      }
    );
  }

  componentDidMount() {
    const {dispatch, params, product} = this.props;

    if (product === undefined) {
      dispatch(fetchProductBySlug(params.splat));
    }

    if (product) {
      const image = closestBackgroundImage(product, product.mainTaxon, ...product.mainTaxonParents.slice().reverse());

      dispatch(setBackground(image));
      dispatch(analyticsClearEcommerce());
      dispatch(analyticsProductDetailsView(product));
      dispatch(analyticsViewProductOrCategory(product.mainTaxon));
      dispatch(setAlternateResources(product.alternateSlugs, '/service'));
      dispatch(setMainTaxonDropdownVisibility(true));

      ProductPage.fetchRelatedData(this.props);
      this.loadProductReviews(product);
    }
  }

  componentDidUpdate(prevProps) {
    const {dispatch, params, product} = this.props;

    if (product === undefined) {
      dispatch(fetchProductBySlug(params.splat));
    }

    if (product && product !== prevProps.product) {
      const image = closestBackgroundImage(product, product.mainTaxon, ...product.mainTaxonParents.slice().reverse());

      dispatch(setBackground(image));
      dispatch(analyticsClearEcommerce());
      dispatch(analyticsProductDetailsView(product));
      dispatch(analyticsViewProductOrCategory(product.mainTaxon));
      dispatch(setAlternateResources(product.alternateSlugs, '/service'));
      dispatch(setMainTaxonDropdownVisibility(true));

      ProductPage.fetchRelatedData(this.props);
      this.loadProductReviews(product);
    }
  }

  componentWillUnmount() {
    const {dispatch} = this.props;
    dispatch(setMainTaxonDropdownVisibility(false));
  }

  onProductPurchase = product => {
    const {dispatch} = this.props;

    return dispatch(addProductToCart(product)).then(() => dispatch(openModal(CartModalContainer)))
  };

  onQuickPurchase = product => {
    const {dispatch, channelFormatters} = this.props;

    return dispatch(addProductToCart(product)).then(() =>
      browserHistory.push(channelFormatters.link('/checkout')),
    );
  };

  onContactSupport = () => {
    if (window.Intercom) {
      window.Intercom('showNewMessage');
    }
  };

  render() {
    const {intl, location, product, productEvents, menu, channelFormatters, isLoading, isError, activeChannel} = this.props;

    const mainTaxonSlug = (product && product.mainTaxon) ? product.mainTaxon.slug : undefined;
    const mainTaxonParentSlugs = (product && product.mainTaxonParents)
      ? product.mainTaxonParents.filter(taxon => taxon.code !== 'game').map(taxon => taxon.slug)
      : [];

    const taxonSlugs = [mainTaxonSlug, ...mainTaxonParentSlugs];

    if (Cookie.get('blacklist')) {
      const excludedTaxons = JSON.parse(Cookie.get('blacklist'));

      // Spread the taxonSlugs array correctly when checking if any of the taxons are excluded
      if (excludedTaxons.some(excludedTaxon => taxonSlugs.includes(excludedTaxon))) {
        return <ErrorPage />;
      }
    }

    if (product === false || isError && productEvents === false) {
      return <ErrorPage/>;
    }

    if (!product || isLoading && !productEvents) {
      return <Loader page/>;
    }

    const breadcrumbs = buildBreadcrumbsList(product.mainTaxon);
    const menuTree = (menu && !!menu.length) && taxonNestedSet.nest(menu);
    const relatedProducts = product.associations.find(it => it.type.code === ProductPage.associationCode);
    const productMeta = product.metatag || {};

    const productOccurrences = itemOccurrences(productEvents);

    let initialOccurrence;
    if (productOccurrences) {
      initialOccurrence = productOccurrences.find(occurrence => occurrence.id == location.query.eventId && occurrence.occurrence === location.query.occurrence);

      if (!initialOccurrence) {
        initialOccurrence = productOccurrences[0];
      }
    }


    return (
      <React.Fragment>
        {!!product.images.length && product.images[0].path && (
          <Helmet>
            <link rel="preload" href={channelImageUrl(product.images[0].path)} as="image"/>
          </Helmet>
        )}

        <div>
          <Meta
            title={productMeta.pageTitle}
            fallbackTitle={product.name}
            description={productMeta.description}
            keywords={productMeta.keywords}
            image={!!product.images.length && product.images[0].path}
            canonical={Object.keys(canonicalMap).includes(product.slug) ? canonicalMap[product.slug] : undefined}
            meta={Object.keys(metaMap).includes(product.slug) ? metaMap[product.slug] : undefined}
            alternateSlug={product.alternateSlugs && product.alternateSlugs.default && ('service/' + product.alternateSlugs.default.slug)}
          />

          <JSONLDBreadcrumbs
            links={[
              {
                name: intl.formatMessage({ id: "section.breadcrumbs.home" }),
                to: ChannelLink.formatLink(activeChannel, "/"),
              },
              ...breadcrumbs.map((it) => ({
                name: it.name,
                to: `${ChannelLink.formatLink(activeChannel, it.slug)}`,
              })),
              { name: product.name },
            ]}
          />

          <JSONLDBoosthive />

          <div className="container">
            <div className="row  page-product">
              <Menu items={menuTree || []} breadcrumbs={breadcrumbs}/>

              <div className="page-product__content">
                <div className='page-product__content-main'>
                  <div className='page-product__content-top'>
                    <Breadcrumbs links={breadcrumbs.map(it => ({name: it.name, to: `/${it.slug}`}))}/>

                    <h1>{(product.metatag && product.metatag.headTitle) || product.name}</h1>
                  </div>

                  <div className='page-product__content-desc'>
                    <WysiwygHtml content={product.description} />
                  </div>
                </div>

                  <div className="page-product__content-sidebar">
                    <ProductPurchase
                      product={product}
                      occurrences={productOccurrences}
                      initialVariant={location.query.variant}
                      initialOccurrence={initialOccurrence}
                      onPurchase={this.onProductPurchase}
                      onQuickPurchase={this.onQuickPurchase}
                      onContactSupport={this.onContactSupport}
                    />
                  </div>
              </div>
            </div>

            <JSONLDProduct
              sku={product.code}
              url={`${process.env.PUBLIC_URL}${ChannelLink.formatLink(activeChannel, 'service/' + product.slug)}`.replace(/\/+$/, '')}
              name={product.name}
              description={product.metatag.description}
              image={channelImageUrl(product.images.length && product.images[0].path)}
              inStock={!!product.inStock}
              price={formatPrice(product.price)}
              currency={channelFormatters.currencyCode()}
              reviews={this.state.productReviews}
            />

            <div className="page-product__carousel">
              <div className="page-product__reviews">
                <ReviewsSwiper productCode={product.code} productReviews={this.state.productReviews} />
              </div>
            </div>

            {(relatedProducts && relatedProducts.associatedProducts) && (
              <div className='page-product__associated-products'>
                <h3>{relatedProducts.type.name}</h3>
                <Products products={relatedProducts.associatedProducts} mainProduct={product} related />
              </div>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}




// WEBPACK FOOTER //
// ./containers/productPage/ProductPage.js